import { alertLabels, outboundExchangeKey, parcelTypes } from '../constants'

export const isInboundParcel = parcel => parcel?.type === parcelTypes.inbound

export const getParcelTypeKey = (type, isExchange) => {
  return type === parcelTypes.outbound && isExchange ? outboundExchangeKey : type
}

export const isTrackingParcel = parcel => parcel?.type === parcelTypes.tracking

export const getParcelAlertLabel = parcel => {
  if (isInboundParcel(parcel)) return null

  return alertLabels[parcel?.related?.alert_type] ?? null
}

export const isInternationalAddresses = (senderAddress, recipientAddress) => {
  return senderAddress?.country?.code !== recipientAddress?.country?.code
}

export const getParcelAddressText = (address, locationName) => {
  const country = `(${address?.country?.code})`
  const province = address?.province?.name
  const locationNameText = locationName ? `${locationName}, ` : ''

  if (province) return `${locationNameText}${province} ${country}`

  return `${locationNameText}${country}`
}

export const getParcelSenderName = parcel => {
  if (isInboundParcel(parcel)) return null

  return parcel?.related?.sender_location?.name ?? null
}

export const getParcelRecipientName = parcel => {
  if (isInboundParcel(parcel)) return null

  const recipientAddress = parcel?.related?.recipient_address

  if (!recipientAddress) return null

  return [recipientAddress.first_name, recipientAddress.last_name].filter(Boolean).join(' ') || null
}

export const parcelHasAlert = parcel => {
  if (isInboundParcel(parcel)) return Boolean(parcel?.related?.has_alerts)

  return Boolean(parcel?.related?.alert_type)
}

export const getParcelItemsQuantity = parcel => parcel?.items_quantity ?? null

export const getParcelSequenceInfo = parcel => {
  const related = parcel?.related

  if (!related) return null

  if (isInboundParcel(parcel)) {
    return { position: related.sequence_number, total: related.returns_in_order }
  }

  return { position: related.sequence_number, total: related.shipments_in_order }
}

export const getParcelCustomerAddress = parcel => {
  if (isTrackingParcel(parcel)) return parcel?.destination
  if (isInboundParcel(parcel)) return parcel?.related?.customer_address || parcel?.origin

  return parcel?.related?.customer_address || parcel?.related?.recipient_address
}

export const getParcelCustomerContactAddress = parcel => {
  if (isInboundParcel(parcel)) return parcel?.origin

  return parcel?.related?.recipient_address
}
